export interface UnknownSerializedAccount {
  type: 'com.victorlevasseur.account-manager.file';
  version: number;
}

export const isSerializedAccount = (
  data: unknown
): data is UnknownSerializedAccount => {
  return (
    typeof data === 'object' &&
    data != null &&
    'type' in data &&
    data.type === 'com.victorlevasseur.account-manager.file' &&
    'version' in data &&
    typeof data.version === 'number'
  );
};
